import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentageChange',
  standalone: true,
})
export class PercentageChangePipe implements PipeTransform {
  transform(current: number, previous: number): string {
    if (previous === 0) return '–'; // avoid divide by zero

    const change = ((current - previous) / previous) * 100;
    const formatted = change.toFixed(2).replace('.', ','); // German comma format

    // Add + or − sign
    return (change > 0 ? '+' : '') + formatted + '\u00A0%';
  }
}
